import { Box, Flex, HStack, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { bellIcon, heartNav, homeIcon, userIcon } from '../../pages/dashboard/components/Icons';
import styled from 'styled-components';

const BottomNav = ({ title, isEmpty }) => {
    const navigate = useNavigate();

    return (
        <>
            {title !== '/dashboard/store' && !title.includes('/dashboard/order-details') && (
                // !title.includes('/dashboard/checkout') &&
                <BottomNavContainer>
                    <HStack
                        pos="fixed"
                        zIndex="99"
                        bottom="0"
                        justify="center"
                        w="full"
                        h="3rem"
                        bg="white"
                        style={{ padding: '0 24px' }}>
                        <Box
                            onClick={() => {
                                navigate('/dashboard', { replace: true });
                            }}
                            maxWidth={'20%'}
                            paddingTop={'12px'}
                            paddingBottom={'12px'}
                            className={title === '/dashboard' ? 'active-link' : ''}>
                            <Flex margin={'0 auto'} justifyContent={'center'}>
                                {homeIcon}
                            </Flex>
                            <Text
                                fontSize={'10px'}
                                margin={'0 auto'}
                                width={'60px'}
                                className={title === '/dashboard' ? 'active-link' : ''}
                                textAlign={'center'}
                                opacity={'0.5'}>
                                Home
                            </Text>
                        </Box>
                        <Box
                            justify="center"
                            flex="1"
                            textAlign="center"
                            maxWidth={'20%'}
                            paddingTop={'12px'}
                            paddingBottom={'12px'}
                            className={
                                title === '/dashboard/import' || isEmpty !== undefined
                                    ? 'active-link'
                                    : ''
                            }
                            onClick={() => {
                                navigate('/dashboard/import', { replace: true });
                            }}>
                            <Flex margin={'0 auto'} justifyContent={'center'}>
                                {heartNav}
                            </Flex>
                            <Text
                                fontSize={'10px'}
                                margin={'0 auto'}
                                width={'60px'}
                                className={title === '/dashboard/import' ? 'active-link' : ''}
                                opacity={'0.5'}>
                                Wishlist
                            </Text>
                        </Box>

                        <Box width={'2rem'} />
                        <Box
                            justify="center"
                            className={title === '/dashboard/messages' ? 'active-link' : ''}
                            flex="1"
                            maxWidth={'20%'}
                            paddingTop={'12px'}
                            paddingBottom={'12px'}
                            onClick={() => {
                                navigate('/dashboard', { replace: true });
                            }}>
                            <Flex margin={'0 auto'} justifyContent={'center'}>
                                {bellIcon}
                            </Flex>
                            <Text
                                fontSize={'10px'}
                                margin={'0 auto'}
                                width={'60px'}
                                className={title === '/dashboard/messages' ? 'active-link' : ''}
                                textAlign={'center'}
                                opacity={'0.5'}>
                                Notification
                            </Text>
                        </Box>

                        <Box
                            justify="center"
                            flex="1"
                            maxWidth={'20%'}
                            paddingTop={'12px'}
                            paddingBottom={'12px'}
                            className={
                                title === '/dashboard/profile/user' ||
                                title === '/dashboard/profile/partner' ||
                                title === '/dashboard/settings'
                                    ? 'active-link'
                                    : ''
                            }
                            onClick={() => {
                                navigate('/dashboard/settings', { replace: true });
                            }}>
                            <Flex margin={'0 auto'} justifyContent={'center'}>
                                {userIcon}
                            </Flex>
                            <Text
                                fontSize={'10px'}
                                margin={'0 auto'}
                                width={'60px'}
                                className={
                                    title === '/dashboard/profile/user' ||
                                    title === '/dashboard/profile/partner' ||
                                    title === '/dashboard/settings'
                                        ? 'active-link'
                                        : ''
                                }
                                textAlign={'center'}
                                opacity={'0.5'}>
                                Settings
                            </Text>
                        </Box>
                    </HStack>
                </BottomNavContainer>
            )}
        </>
    );
};

export default BottomNav;
const BottomNavContainer = styled.section`
    .active-link {
        svg {
            path {
                stroke: #1b3b5f;
            }
        }
    }
    @media screen and (max-width: 500px) {
        padding-top: 3.5rem;
    }
`;
